export default __webpack_public_path__ + "static/media/Avatar-28-noback.a779fe20.png";